import { Grid, Typography } from '@mui/material';
import React from 'react'
import styles from '../../../../../../../assets/styles/componentStyles/templatemessages.module.scss'

interface templateBodyPreview {
    footerText: string,
    isCarouselTemplate?: boolean,
}

function TemplateFooterPreview(props: templateBodyPreview) {
    const { footerText } = props;
    
    return (
        <>
            <Grid item className={styles.templatePrviewFooterItem} dir="auto">
                <pre
                    className={styles.preTextStyle}
                    dangerouslySetInnerHTML={{ __html: footerText }}
                />
            </Grid>
        </>
    )
}

export default TemplateFooterPreview